import { Outlet } from 'react-router-dom';
import { Header } from '../components/layout/Header';
import { BottomNav } from '../components/layout/BottomNav';
import { FloatingActionButton } from '../components/ui/FloatingActionButton';
import { useTheme } from '../context/ThemeContext';

export function MainLayout() {
  const { isDark } = useTheme();

  return (
    <div className="b2b min-h-[100dvh] flex flex-col" data-theme={isDark ? 'dark' : 'light'}>
      <Header />
      <main className="flex-1 nav-safe-pad pt-6 px-4 md:px-6 lg:px-8 safe-area-inset-x">
        <div className="mx-auto w-full max-w-6xl">
          <Outlet />
        </div>
      </main>
      <BottomNav />
      <FloatingActionButton />
    </div>
  );
}
